import type { AgentsTranslations } from '../interfaces/agents';

export const agentsTranslations: AgentsTranslations = {
  page_title: 'Agentes',
  page_description:
    'Gerencie os agentes de IA que respondem por você. Crie um por caso de uso e ajuste sua configuração.',
  empty_title: 'Você ainda não tem agentes',
  empty_description:
    'Crie seu primeiro agente para começar a automatizar conversas com seus clientes.',
  create_button: 'Criar agente',
  back_to_list: 'Voltar para agentes',

  agent_type_ecommerce: 'E-commerce',
  agent_type_real_estate: 'Imobiliário',
  agent_type_fintech: 'Fintech',
  template_ecommerce_default: 'Padrões de e-commerce',
  template_real_estate_default: 'Padrões imobiliários',
  template_fintech_default: 'Padroes fintech',
  template_empty: 'Vazio',

  status_active: 'Ativo',
  status_inactive: 'Inativo',
  status_draft: 'Rascunho',

  card_actions_label: 'Ações do agente',
  action_edit: 'Editar',
  action_duplicate: 'Duplicar',
  action_activate: 'Ativar',
  action_deactivate: 'Desativar',
  action_mark_draft: 'Mover para rascunho',
  action_unmark_draft: 'Tirar do rascunho',
  action_delete: 'Excluir',

  create_page_title: 'Criar novo agente',
  create_page_description:
    'Escolha um nome e um modelo inicial. Você poderá ajustar tudo em seguida.',
  create_tab_manual: 'Manual',
  create_tab_files: 'Enviar arquivos',
  create_field_name_label: 'Nome',
  create_field_name_placeholder: 'Ex.: Minha Loja – WhatsApp',
  create_field_name_help: 'Deve ser único na sua organização.',
  create_field_type_label: 'Tipo de agente',
  create_field_template_label: 'Modelo inicial',
  create_field_template_help:
    'O modelo preenche valores padrão; você poderá sobrescrever tudo depois.',
  create_submit: 'Criar agente',
  create_files_section_title: 'Arquivos de origem (opcional)',
  create_files_section_description:
    'Solte documentos (PDF, DOCX, TXT, MD, CSV) que descrevam seu negócio. Serão usados para preencher a configuração quando o pipeline de ingestão estiver disponível.',
  create_files_pending_notice:
    'O processamento de arquivos está em preparação. Os arquivos ficam anexados ao rascunho e serão processados quando o backend suportar.',

  dropzone_idle: 'Arraste arquivos aqui ou clique para selecionar',
  dropzone_active: 'Solte os arquivos para anexá-los',
  dropzone_hint: 'PDF, DOCX, TXT, MD, CSV — até 10 arquivos, 20 MB cada.',
  dropzone_remove: 'Remover arquivo',
  dropzone_size_unit_b: 'B',
  dropzone_size_unit_kb: 'KB',
  dropzone_size_unit_mb: 'MB',

  duplicate_dialog_title: 'Duplicar agente',
  duplicate_dialog_description:
    'Escolha um novo nome. A configuração inteira é copiada; o duplicado começa ativo.',
  duplicate_dialog_field_label: 'Novo nome',
  duplicate_dialog_confirm: 'Duplicar',
  duplicate_dialog_cancel: 'Cancelar',

  delete_dialog_title: 'Excluir este agente?',
  delete_dialog_description:
    'Ele para de responder mensagens imediatamente. Exclusão lógica; o nome não é liberado.',
  delete_dialog_confirm: 'Excluir agente',
  delete_dialog_cancel: 'Cancelar',

  edit_page_loading: 'Carregando agente…',
  edit_page_not_found_title: 'Agente não encontrado',
  edit_page_not_found_description:
    'Pode ter sido excluído ou você pode não ter acesso. Volte para a lista e tente novamente.',
  edit_save: 'Salvar alterações',
  edit_saving: 'Salvando…',
  edit_discard: 'Descartar alterações',
  edit_no_changes_hint: 'Sem alterações pendentes.',
  edit_field_name_label: 'Nome',
  edit_schema_loading: 'Carregando esquema de configuração…',
  edit_schema_error: 'Não foi possível carregar o esquema.',
  edit_schema_retry: 'Tentar novamente',
  edit_view_mode_form: 'Formulário',
  edit_view_mode_json: 'JSON',
  edit_nav_search_placeholder: 'Buscar seções…',
  edit_nav_group_label: 'Configuração do agente',
  edit_test_with_customer: 'Testar com cliente',
  edit_test_with_customer_coming_soon: 'Em breve',
  edit_view_in_production: 'Ver em produção',
  edit_view_in_production_inactive: 'Ative o agente primeiro',
  edit_breadcrumb_root: 'Agentes',
  edit_unsaved_pill: 'Alterações pendentes',

  hero_agent_label: 'Agente',
  hero_agent_of: 'Agente de',
  hero_subtitle:
    'Tudo o que você pode configurar neste agente: identidade, modelo, tom, dados, objetivos, handoffs e follow-ups.',
  identity_sandbox: 'Testar no sandbox',
  identity_timezone_label: 'Fuso horário',
  identity_timezone_placeholder: 'Escolha um fuso horário…',
  identity_status_label: 'Status',
  identity_status_help: 'Use o menu de ações para ativar ou pausar.',
  identity_status_inline_hint:
    'O status é gerenciado a partir do menu de ações na barra superior.',

  llm_main_title: 'Modelo principal',
  llm_model_label: 'Modelo',
  llm_model_placeholder: 'Selecione um modelo…',
  llm_overrides_title: 'Overrides por tarefa',
  llm_overrides_description:
    'Use um modelo diferente para tarefas específicas (classificação, extração, perfilamento).',
  llm_overrides_placeholder:
    'Overrides por tarefa estarão disponíveis em breve. Enquanto isso, o modelo principal será usado para todas as tarefas.',

  tone_preferred_title: 'Palavras preferidas',
  tone_preferred_help: 'Vocabulário da marca que o agente deve priorizar.',
  tone_forbidden_title: 'Palavras proibidas',
  tone_forbidden_help: 'Sempre evitadas e bloqueadas nas respostas.',
  tone_guard_title: 'Tópicos no escopo',
  tone_guard_help:
    'Assuntos que o guard NÃO deve bloquear. O agente pode tratá-los mesmo que pareçam fora do contexto à primeira vista.',
  field_guard_topics_label: 'Tópicos no escopo',
  field_guard_topics_help:
    'Lista de tópicos que o guard considera dentro do escopo. Útil para casos em que o cliente menciona algo emocional ou tangencial que ainda faz parte do contexto da marca (ex. "amor", "dinheiro", "ansiedade").',

  examples_add: 'Adicionar exemplo',
  examples_question_label: 'Pergunta do cliente',
  examples_answer_label: 'Resposta ideal',
  examples_remove: 'Remover exemplo',
  examples_empty: 'Sem exemplos ainda — recomenda-se 4-8.',
  examples_counter: '{{count}} exemplos · recomenda-se 4-8',

  prompt_helper:
    '{{count}} caracteres · injetado após a descrição da marca e o tom',

  data_add: 'Adicionar campo',
  data_remove: 'Remover campo',
  data_required_label: 'Campo obrigatório',
  data_empty: 'Sem campos configurados ainda.',
  data_col_key: 'Chave',
  data_col_display: 'Nome visível',
  data_col_type: 'Tipo',
  data_col_stage: 'Etapa',

  data_group_label: 'Grupo {{index}}',
  data_group_when_prefix: 'Se',
  data_group_always_active: 'Sempre ativo',
  data_group_field_count: '{{count}} campos',
  data_group_condition_hint:
    'As condições são somente leitura até o backend expô-las.',
  data_group_empty: 'Ainda não há campos neste grupo.',
  data_group_add: 'Adicionar grupo',
  data_group_remove: 'Remover grupo',
  data_field_add: 'Adicionar campo',
  data_field_display_placeholder: 'ex. Email do cliente',
  data_field_key_label: 'Chave',
  data_field_key_help:
    'Identificador em snake_case salvo no CRM. Gerado automaticamente a partir do nome visível; edite apenas se necessário.',
  data_field_key_hint: 'Chave interna usada pelo CRM e integrações.',
  data_field_type_label: 'Tipo',
  data_field_stage_label: 'Etapa',
  data_field_options_label: 'Opções válidas',
  data_field_options_help:
    'Lista de valores permitidos. O agente só pode salvar um destes.',
  data_field_options_placeholder: 'Digite e pressione Enter…',
  data_field_question_label: 'Modelo de pergunta',
  data_field_question_help:
    'O agente usa isto como modelo — o LLM pode parafrasear conforme o tom.',
  data_field_question_placeholder: 'ex. Qual é o seu email?',
  data_field_validation_label: 'Regra de validação',
  data_field_validation_help:
    'Regra em texto livre que o LLM aplica (ex. "deve conter @").',
  data_field_validation_placeholder: 'ex. formato de email válido',
  data_field_required_label: 'Obrigatório',
  data_field_required_chip: 'Obrigatório',
  data_field_required_help: 'Deve ser coletado antes de fechar a conversa.',
  data_field_extractable_label: 'Extraível de mídia',
  data_field_extractable_help:
    'Quando ativo, o agente pode extrair este dado de foto ou áudio (ex. receita médica).',
  data_field_advanced_toggle: 'Avançado',

  labels_add: 'Adicionar etiqueta',
  labels_remove: 'Remover etiqueta',
  labels_empty: 'Sem etiquetas configuradas ainda.',
  labels_col_key: 'Chave',
  labels_col_display: 'Nome visível',
  labels_col_tone: 'Cor',

  capabilities_title: 'Capacidades',
  capabilities_empty:
    'Sem capacidades definidas. Adicione o que o agente PODE fazer.',
  capabilities_add: 'Adicionar capacidade',
  capabilities_what_label: 'O que pode fazer',
  capabilities_what_placeholder: 'Ex.: Tomar pedidos, recomendar produtos',
  capabilities_desc_label: 'Detalhe',
  capabilities_desc_placeholder: 'Como faz, em que casos, exemplos de uso',
  limitations_title: 'Nunca faz',
  limitations_empty:
    'Sem limites definidos. Adicione o que o agente NÃO deve fazer.',
  limitations_add: 'Adicionar limite',
  limitations_what_label: 'O que NÃO pode fazer',
  limitations_what_placeholder:
    'Ex.: Agendar consultas, dar diagnóstico médico',
  limitations_desc_label: 'Detalhe',
  limitations_desc_placeholder: 'Como se manifesta, o que evitar exatamente',
  limitations_redirect_label: 'Mensagem exata quando pedirem (opcional)',
  limitations_redirect_placeholder:
    'Ex.: "Para agendar, escreva-nos para suporte@..."',
  limitations_redirect_hint:
    'Se ficar vazio, o agente responderá educadamente sem prometer a ação.',
  common_remove: 'Remover',

  goal_milestones_title: 'Marcos antes do CTA',
  goal_milestones_add: 'Adicionar marco',
  goal_milestones_remove: 'Remover marco',
  goal_opening_title: 'Abertura da conversa',
  goal_opening_description:
    'Como o agente cumprimenta no primeiro turno e exemplos concretos.',
  goal_opening_examples_label: 'Exemplos de abertura',
  goal_opening_examples_add: 'Adicionar exemplo',
  goal_opening_examples_remove: 'Remover exemplo',

  messaging_preview_label: 'Pré-visualização aproximada',

  rag_enabled_title: 'Retrieval-Augmented Generation',
  rag_enabled_description:
    'Quando ativo, o agente busca nas suas fontes antes de responder.',
  rag_sources_hint: 'Gerencie as fontes carregadas na seção de Fontes acima.',
  rag_tools_title: 'Ferramentas externas',
  rag_tools_description:
    'Funções que o agente pode chamar (APIs, bancos de dados, webhooks).',
  rag_tools_empty: 'Nenhuma ferramenta conectada ainda.',

  handoff_enabled_title: 'Passar para um humano',
  handoff_enabled_description:
    'Quando ativo, o agente para e notifica um humano se algum gatilho corresponder.',
  handoff_col_type: 'Tipo',
  handoff_col_value: 'Gatilho',
  handoff_col_reason: 'Razão',
  handoff_add: 'Adicionar gatilho',
  handoff_remove: 'Remover gatilho',

  toast_created: 'Agente criado.',
  toast_updated: 'Agente atualizado.',
  toast_duplicated: 'Agente duplicado.',
  toast_activated: 'Agente ativado.',
  toast_deactivated: 'Agente desativado.',
  toast_drafted: 'Agente movido para rascunho.',
  toast_undrafted: 'Agente tirado do rascunho.',

  wizard_step_basics: 'Dados básicos',
  wizard_step_docs: 'Documentos',
  wizard_choice_empty_title: 'Começar do zero',
  wizard_choice_empty_description:
    'Crie um agente vazio e configure tudo manualmente.',
  wizard_choice_from_docs_title: 'Gerar a partir de documentos',
  wizard_choice_from_docs_description:
    'Envie de 1 a 10 documentos e nós pré-preenchemos o agente.',
  wizard_continue: 'Continuar',
  wizard_back: 'Voltar',
  wizard_generate_button: 'Gerar agente',
  wizard_skip_to_create: 'Pular — criar vazio',
  wizard_files_required: 'Adicione ao menos um arquivo para gerar.',

  generation_status_queued: 'Na fila…',
  generation_status_running: 'Gerando seu agente…',
  generation_status_failed: 'A geração falhou',
  generation_status_success: 'Pronto!',
  generation_progress_label: '{{completed}} de {{total}} etapas',

  generation_node_document_loader: 'Lendo documentos',
  generation_node_language_detector: 'Detectando o idioma',
  generation_node_brand_extractor: 'Capturando a voz da marca',
  generation_node_domain_extractor: 'Mapeando o negócio',
  generation_node_qa_extractor: 'Montando a base de conhecimento',
  generation_node_link_extractor: 'Coletando links',
  generation_node_data_fields_suggester: 'Escolhendo o que perguntar',
  generation_node_config_synthesizer: 'Compondo o agente',

  generation_error_first_title: 'Algo deu errado',
  generation_error_first_description:
    'Não conseguimos terminar de gerar o agente. Tente de novo.',
  generation_error_retry_button: 'Tentar de novo',
  generation_error_persistent_title: 'Continua falhando',
  generation_error_persistent_description:
    'Há um problema persistente. Espere alguns minutos e tente de novo, ou abra o editor e configure manualmente — seu rascunho está salvo.',
  generation_error_go_to_editor_button: 'Abrir editor',

  toast_generation_success: 'Seu agente está pronto.',
  toast_generation_failed: 'Não foi possível gerar o agente.',
  toast_deleted: 'Agente excluído.',
  toast_files_pending:
    'Os arquivos foram anexados localmente; serão processados quando o backend suportar.',

  error_display_name_taken: 'Esse nome já está em uso na sua organização.',
  error_validation:
    'Alguns campos têm valores inválidos. Revise-os e tente novamente.',
  error_validation_summary:
    '{{count}} campos têm valores inválidos. Primeiro: {{first}}',
  error_load_list: 'Não foi possível carregar seus agentes. Tente novamente.',
  error_load_one: 'Não foi possível carregar este agente.',
  error_load_schema: 'Não foi possível carregar o esquema.',
  error_agent_type_not_allowed:
    'Sua organização não pode criar agentes deste tipo.',
  error_unknown: 'Algo deu errado. Tente novamente.',

  create_loading_types: 'Carregando tipos de agente disponíveis…',
  create_no_types_title: 'Sem tipos de agente disponíveis',
  create_no_types_description:
    'Sua organização ainda não tem tipos de agente habilitados. Contate o suporte para ativá-los.',

  sources_section_title: 'Arquivos de origem (RAG)',
  sources_section_description:
    'Envie documentos que descrevam seu negócio. O agente os usa como base de conhecimento em cada resposta.',
  sources_empty_title: 'Ainda não há arquivos',
  sources_empty_description:
    'Arraste um PDF, DOCX, TXT, MD, CSV ou XLSX para alimentar o agente.',
  sources_upload_hint:
    'Arraste arquivos ou clique — PDF, DOCX, TXT, MD, CSV, XLSX. Até 10 MB cada.',
  sources_upload_active: 'Solte os arquivos para adicioná-los',
  sources_uploading: 'Enviando {{name}}…',
  sources_pending_title: 'Prontos para enviar ({{count}})',
  sources_pending_remove: 'Remover arquivo',
  sources_pending_clear: 'Remover todos',
  sources_pending_upload: 'Enviar {{count}}',
  sources_pending_uploading: 'Enviando…',
  sources_loading: 'Carregando arquivos…',
  sources_load_error: 'Não foi possível carregar os arquivos.',
  sources_retry: 'Tentar novamente',

  source_status_processing: 'Processando…',
  source_status_ready: 'Pronto',
  source_status_failed: 'Erro',
  source_qa_disabled: 'Q&A desativado',
  source_qa_pending: 'Q&A na fila',
  source_qa_processing: 'Gerando Q&A…',
  source_qa_ready: 'Q&A pronto',
  source_qa_failed: 'Q&A falhou',
  source_qa_label: 'Gerar arquivo Q&A automático',
  source_qa_help:
    'Criamos um arquivo de perguntas e respostas a partir deste documento. Melhora bastante a qualidade do RAG. (Recomendado)',
  source_active_label: 'Ativo',
  source_active_help:
    'Se desativado, o agente deixa de consultá-lo em suas respostas.',
  source_pair_count: '{{count}} pares Q&A',
  source_updated_ago: 'Atualizado {{when}}',

  source_action_preview: 'Ver arquivo',
  source_action_preview_qa: 'Ver Q&A',
  source_action_regenerate_qa: 'Regenerar Q&A',
  source_action_delete: 'Excluir',

  source_delete_title: 'Excluir este arquivo?',
  source_delete_description:
    'Ele será removido do armazenamento e da base de conhecimento do agente imediatamente.',
  source_delete_confirm: 'Excluir arquivo',

  toast_source_uploaded: 'Arquivo enviado — processando em segundo plano.',
  toast_source_updated: 'Arquivo atualizado.',
  toast_source_deleted: 'Arquivo excluído.',
  toast_source_qa_queued: 'Regeneração de Q&A na fila.',
  toast_source_preview_opened: 'Abrindo visualização…',

  error_source_file_too_large: 'O arquivo excede o limite de 10 MB.',
  error_source_unsupported:
    'Formato não suportado. Use PDF, DOCX, TXT, MD, CSV ou XLSX.',
  error_source_no_text:
    'Não foi possível extrair texto do arquivo. Tente outro documento.',
  error_source_qa_disabled: 'Habilite Q&A antes de regenerá-lo.',
  error_source_qa_not_generated: 'Este arquivo ainda não tem Q&A gerado.',
  error_source_upload: 'Não foi possível enviar o arquivo. Tente novamente.',
  error_source_delete: 'Não foi possível excluir o arquivo.',
  error_source_update: 'Não foi possível atualizar o arquivo.',
  error_source_preview: 'Não foi possível abrir o arquivo.',

  preview_title: 'Pré-visualização',
  preview_loading: 'Carregando pré-visualização…',
  preview_fetch_error:
    'Não foi possível carregar o arquivo para pré-visualização.',
  preview_not_supported:
    'Pré-visualização não disponível para este tipo de arquivo.',
  preview_csv_truncated:
    'Mostrando apenas as primeiras {{count}} linhas. Baixe o arquivo para ver tudo.',
  preview_download: 'Baixar',

  qa_editor_title: 'Pares Q&A',
  qa_editor_pair_count: '{{count}} pares',
  qa_editor_add_pair: 'Adicionar par',
  qa_editor_question_label: 'Pergunta',
  qa_editor_answer_label: 'Resposta',
  qa_editor_remove_pair: 'Remover par',
  qa_editor_save: 'Salvar alterações',
  qa_editor_cancel: 'Cancelar',
  qa_editor_loading: 'Carregando pares Q&A…',
  qa_editor_fetch_error: 'Não foi possível carregar os pares Q&A.',
  qa_editor_empty: 'Ainda não há pares. Adicione o primeiro.',

  toast_qa_content_saved: 'Pares Q&A salvos.',
  error_qa_content_save:
    'Não foi possível salvar os pares Q&A. Tente novamente.',

  section_identity_title: 'Identidade e marca',
  section_identity_subtitle:
    'Quem é o agente, qual é a voz dele e em que contexto opera.',
  section_llm_title: 'Modelo (LLM)',
  section_llm_subtitle:
    'O cérebro do agente. Você pode sobrescrever o modelo para tarefas específicas como perfilamento de leads.',
  section_tone_title: 'Tom e vocabulário',
  section_tone_subtitle: 'Como o agente fala e quais palavras usar ou evitar.',
  section_examples_title: 'Exemplos de estilo',
  section_examples_subtitle:
    'Pares pergunta-resposta que ilustram o tom ideal. O modelo os usa como few-shot.',
  section_prompt_title: 'Instruções do sistema',
  section_prompt_subtitle:
    'Regras adicionais anexadas ao system prompt — políticas de produto, pagamentos e conversa.',
  section_data_title: 'Dados a coletar',
  section_data_subtitle:
    'Informações que o agente deve extrair durante a conversa. Defina a pergunta, a etapa e as regras de validação.',
  section_labels_title: 'Etiquetas',
  section_labels_subtitle:
    'O agente etiqueta automaticamente as conversas para segmentar leads e disparar workflows.',
  section_capabilities_title: 'Capacidades e limites',
  section_capabilities_subtitle:
    'O que o agente pode fazer e o que NUNCA deve fazer. Ambos são injetados no system prompt.',
  section_goal_title: 'Objetivo do agente',
  section_goal_subtitle:
    'O que ele tenta atingir e quão agressivo é ao chegar no CTA.',
  section_messaging_title: 'Estilo de mensagens',
  section_messaging_subtitle:
    'Como as respostas são estruturadas: tamanho, mensagens por turno e estratégia de divisão.',
  section_rag_title: 'RAG e ferramentas',
  section_rag_subtitle:
    'Base de conhecimento que o agente consulta em tempo real, e ferramentas externas que pode chamar.',
  section_handoff_title: 'Handoff para humano',
  section_handoff_subtitle:
    'Condições que pausam o agente e notificam um humano para assumir.',
  section_followup_title: 'Follow-ups',
  section_followup_subtitle:
    'Quando o agente reengaja o cliente que para de responder ou abandona.',
  section_integrations_title: 'Integrações de conversão',
  section_integrations_subtitle:
    'Conecte Shopify ou outro sistema para verificar as compras reais do agente.',

  integration_shopify_title: 'Shopify',
  integration_shopify_description:
    'Receba os pedidos pagos da sua loja Shopify para confirmar conversões reais.',
  integration_shopify_secret_label: 'Signing secret do Shopify',
  integration_shopify_secret_help:
    'Cole aqui o secret que o Shopify mostra ao criar o webhook em Settings → Notifications.',
  integration_shopify_secret_replace_help:
    'Substituir o secret invalida a integração até você colar um novo.',
  integration_shopify_secret_placeholder: 'Cole o signing secret do Shopify',
  integration_shopify_secret_required: 'Cole o signing secret do Shopify',
  integration_shopify_replace_secret: 'Substituir secret',
  integration_shopify_steps_title: 'Como configurar no Shopify',
  integration_shopify_step_1:
    'Vá ao seu Shopify Admin → Settings → Notifications.',
  integration_shopify_step_2:
    'Desça até "Webhooks" e clique em "Create webhook".',
  integration_shopify_step_3:
    'Configure: Event "Order payment", Format "JSON", URL: cole a de cima.',
  integration_shopify_step_4:
    'Depois de criar o webhook, o Shopify mostra um signing secret. Cole-o abaixo.',
  integration_shopify_docs_link: 'Ver documentação oficial do Shopify',
  integration_shop_domain_label: 'Domínio da loja (opcional)',
  integration_shop_domain_help:
    'Ex: minha-loja.myshopify.com. Se deixar vazio, capturamos no primeiro webhook recebido.',

  integration_generic_title: 'Endpoint genérico',
  integration_generic_description:
    'Para Stripe, Mercado Pago ou sistema custom: poste conversões para nossa URL do seu backend.',
  integration_generic_example_title: 'Exemplo cURL',

  integration_webhook_url_label: 'URL do webhook',
  integration_endpoint_url_label: 'URL do endpoint',
  integration_api_key_label: 'Sua API key',
  integration_api_key_hidden_help:
    'Mostramos apenas os últimos 4 caracteres por segurança. Se a perdeu, regere uma nova.',
  integration_api_key_generate: 'Gerar API key',
  integration_api_key_rotate: 'Regerar API key',
  integration_api_key_generated: 'API key gerada',
  integration_save: 'Salvar',
  integration_saved: 'Integração salva',
  integration_save_failed: 'Não foi possível salvar a integração',
  integration_disable: 'Desativar',
  integration_disabled: 'Integração desativada',
  integration_copy: 'Copiar',
  integration_copied: 'Copiado!',
  integration_status_active: 'Ativa',
  integration_status_configured_no_traffic: 'Sem tráfego',
  integration_status_inactive: 'Não configurada',

  credential_modal_title: 'Sua credencial',
  credential_modal_description:
    'Copie agora — por segurança não poderá vê-la de novo.',
  credential_modal_warning:
    'Guarde-a num lugar seguro. Se perdê-la terá que regerar uma nova.',
  credential_modal_copy: 'Copiar',
  credential_modal_copied: 'Copiado',
  credential_modal_close: 'Fechar',

  list_verified_conversions_label: 'Conversões verificadas',
  list_verified_revenue_label: 'Receita',
  list_verified_revenue_mixed: 'multi-moeda',
  list_verified_revenue_mixed_tooltip:
    'As conversões vieram em moedas diferentes — o total não está convertido.',
  list_verified_empty_no_data: 'Aguardando primeira conversão',
  list_verified_empty_no_integration:
    'Conecte uma integração para ver compras reais',
  list_stat_goal_achieved: 'Meta',
  list_stat_goal_achieved_tooltip:
    'Porcentagem de conversas em que o agente concluiu que o objetivo foi atingido (vender, qualificar, agendar, etc.). É a leitura do LLM sobre o chat — útil, mas subjetiva. Para compras reais, veja "Verificadas".',
  list_stat_convs_tooltip:
    'Conversas únicas nos últimos 7 dias. O gráfico mostra a tendência diária.',
  list_stat_verified_short: 'Verificadas',
  list_stat_verified_tooltip_data:
    'Conversas com pelo menos uma compra verificada por uma integração externa (Shopify, endpoint genérico). É ground truth — não opinião do LLM.',
  list_verified_tooltip_revenue: 'Receita',
  list_verified_tooltip_sources: 'Por fonte',
  section_links_title: 'Links',
  section_links_subtitle:
    'URLs oficiais que o agente compartilha com o cliente quando necessário.',

  field_display_name_label: 'Nome visível',
  field_brand_name_label: 'Nome da marca',
  field_persona_name_label: 'Nome da persona do agente',
  field_persona_name_help: 'Como o agente se apresenta nas conversas.',
  field_brand_description_label: 'Descrição',
  field_brand_description_help: 'Contexto da marca injetado no system prompt.',
  field_default_language_label: 'Idioma padrão',
  field_timezone_label: 'Fuso horário',
  field_llm_provider_label: 'Provedor',
  field_llm_model_label: 'Modelo',
  field_llm_model_help:
    'Identificador do modelo por provedor (ex. gpt-4o-mini, claude-sonnet-4-5).',
  field_llm_temperature_label: 'Temperature',
  field_llm_temperature_help: '0 = determinístico, 1 = criativo.',
  field_tone_description_label: 'Descrição do tom',
  field_tone_description_help:
    'Texto livre descrevendo a personalidade. Injetado no system prompt.',
  field_preferred_words_label: 'Palavras preferidas',
  field_preferred_words_help:
    'Vocabulário da marca que o agente deve priorizar.',
  field_forbidden_words_label: 'Palavras proibidas',
  field_forbidden_words_help: 'Sempre evitadas e bloqueadas nas respostas.',
  field_qa_examples_label: 'Exemplos Q&A',
  field_qa_examples_help:
    'Pares que mostram o tom ideal. Usados como few-shot.',
  field_qa_question_label: 'Pergunta do cliente',
  field_qa_answer_label: 'Resposta ideal',
  field_system_prompt_label: 'System prompt (extra)',
  field_system_prompt_help: 'Injetado após a descrição da marca e o tom.',
  field_data_fields_label: 'Dados a coletar',
  field_data_fields_help:
    'Grupos de campos com condições opcionais que ramificam a conversa.',
  field_available_labels_label: 'Etiquetas disponíveis',
  field_agent_capabilities_label: 'Capacidades',
  field_agent_limitations_label: 'Limites (nunca faz)',
  field_goal_type_label: 'Tipo de objetivo',
  field_goal_primary_outcome_label: 'Resultado principal',
  field_goal_primary_outcome_help:
    'O que significa "sucesso" para este agente.',
  field_goal_aggressiveness_label: 'Agressividade do CTA',
  field_goal_aggressiveness_help: 'Quão direto o agente é ao pedir a venda.',
  field_goal_min_turns_label: 'Turnos mínimos antes do CTA',
  field_goal_min_turns_help:
    'O agente nunca pede a venda antes deste número de mensagens.',
  field_goal_milestones_label: 'Marcos antes do CTA',
  field_goal_milestones_help:
    'Condições que devem ser verdadeiras antes de o agente pedir a venda.',
  field_goal_opening_style_label: 'Estilo de abertura',
  field_goal_opening_examples_label: 'Exemplos de abertura',
  field_messaging_conciseness_label: 'Concisão',
  field_messaging_conciseness_help: 'Quão breve o agente responde.',
  field_messaging_split_strategy_label: 'Estratégia de divisão',
  field_messaging_max_messages_label: 'Mensagens máximas por turno',
  field_messaging_target_chars_label: 'Caracteres por mensagem',
  field_messaging_image_cooldown_label: 'Cooldown de imagens (minutos)',
  field_messaging_image_cooldown_help:
    'Minutos mínimos entre duas respostas com imagem.',
  field_rag_enabled_label: 'Retrieval-Augmented Generation',
  field_rag_enabled_help:
    'Quando ativo, o agente busca nas suas fontes antes de responder.',
  field_tools_enabled_label: 'Ferramentas externas',
  field_tools_enabled_help:
    'Funções que o agente pode chamar (APIs, bancos de dados, webhooks).',
  field_handoff_enabled_label: 'Passar para um humano',
  field_handoff_enabled_help:
    'Quando ativo, o agente para e notifica um humano se algum gatilho corresponder.',
  field_handoff_triggers_label: 'Gatilhos',
  field_handoff_message_label: 'Mensagem de escalamento',
  field_handoff_message_help:
    'Mensagem mostrada ao cliente quando o agente escala.',
  quiet_hours_default_title: 'Quiet hours padrão',
  quiet_hours_default_help:
    'Janela de horas em que nenhum follow-up é enviado. Cada regra pode sobrescrever.',
  quiet_hours_using_custom: 'Usando configuração própria',
  rule_new_default_name: 'Nova regra',
  rule_add_custom: 'Adicionar regra',
  rule_remove: 'Remover regra',
  rule_empty: 'Nenhuma regra configurada. Adicione uma para começar.',
  rule_badge_builtin: 'Built-in',
  field_followup_master_enabled_label: 'Ativar follow-ups',
  field_followup_master_enabled_help:
    'Quando desligado, nenhum follow-up dispara para este agente.',
  field_quiet_hours_default_enabled_label: 'Aplicar quiet hours padrão',
  field_quiet_hours_enabled_label: 'Aplicar quiet hours',
  field_quiet_hours_start_label: 'Início',
  field_quiet_hours_end_label: 'Fim',
  field_quiet_hours_days_label: 'Dias',
  field_quiet_hours_override_label: 'Quiet hours específicas para esta regra',
  field_quiet_hours_override_help:
    'Se desligado, usa os quiet hours padrão do agente.',
  field_use_default_quiet_label: 'Usar padrão',
  field_followup_rules_label: 'Regras de follow-up',
  field_followup_rules_help:
    'Built-in (não podem ser apagadas, apenas desativadas) e regras personalizadas.',
  field_rule_name_label: 'Nome',
  field_rule_enabled_label: 'Ativar esta regra',
  field_delay_hours_label: 'Esperar (horas)',
  field_delay_hours_help: 'O relógio pausa durante quiet hours.',
  field_cancel_if_goal_met_label:
    'Não enviar se o agente já cumpriu o objetivo',
  field_cancel_if_goal_met_help:
    'Recomendado. Se o cliente já fez o que o agente buscava (ex.: comprar), este lembrete não é enviado.',
  field_message_override_enabled_label: 'Personalizar mensagem',
  field_message_override_enabled_help:
    'Quando desligado, a IA escreve a mensagem com base na marca e no contexto.',
  field_message_text_label: 'Mensagem',
  field_message_text_help:
    'Variáveis disponíveis: {{customer_name}}, {{brand_name}}, {{rule_name}}, {{cart_count}}, {{cart_total}}.',
  field_message_text_placeholder:
    'Olá {{customer_name}}, conseguiu pensar? Estou aqui para ajudar.',
  rule_summary_after: 'Após',
  rule_summary_skip_if_goal: 'pula se o objetivo for cumprido',
  day_sun: 'Dom',
  day_mon: 'Seg',
  day_tue: 'Ter',
  day_wed: 'Qua',
  day_thu: 'Qui',
  day_fri: 'Sex',
  day_sat: 'Sáb',
  field_links_privacy_label: 'Política de privacidade',
  field_links_terms_label: 'Termos de serviço',
  field_links_help_label: 'Ajuda / contato',
  field_links_about_label: 'Sobre a marca',
  field_links_payment_label: 'URL base de pagamento',
  field_links_catalog_label: 'Catálogo / produto principal',

  field_links_label: 'Links da marca',
  field_links_help:
    'URLs que o agente pode compartilhar com o cliente. Cada link tem uma descrição que diz ao agente o que é e quando enviá-lo.',
  field_link_url_label: 'URL',
  field_link_description_label: 'Descrição',
  field_link_description_help:
    'O que é este link e quando enviá-lo. O agente lê isto para decidir se compartilha o link em uma conversa.',
  field_link_description_placeholder:
    'ex. Política de reembolso — envie quando o cliente perguntar sobre devoluções dentro de 30 dias.',
  field_link_cta_label: 'Texto do botão (override)',
  field_link_cta_help:
    'Texto exato do botão para este link. Deixe vazio para o modelo gerar (≤20 caracteres).',
  field_link_cta_placeholder: 'ex. Pagar agora',
  field_link_type_label: 'Tipo',
  field_link_type_help:
    'Ajuda o agente a priorizar e agrupar os links. Opcional.',
  field_link_type_placeholder: 'Escolha um tipo…',
  field_link_type_product: 'Produto',
  field_link_type_payment: 'Pagamento',
  field_link_type_privacy_policy: 'Política de privacidade',
  field_link_type_terms: 'Termos',
  field_link_type_help_option: 'Ajuda / contato',
  field_link_type_about: 'Sobre a marca',
  field_link_type_faq: 'FAQ',
  field_link_type_social: 'Redes sociais',
  field_link_type_other: 'Outro',
  field_optional_suffix: 'opcional',
  links_item_title: 'Link {{index}}',
  links_add: 'Adicionar link',
  links_remove: 'Remover link',
  links_empty: 'Sem links ainda — adicione um para o agente compartilhar.',
  links_open: 'Abrir link',

  goal_type_sell_label: 'Vender',
  goal_type_sell_desc: 'Conduzir a conversa para uma compra.',
  goal_type_support_label: 'Suporte',
  goal_type_support_desc: 'Resolve dúvidas e problemas.',
  goal_type_qualify_label: 'Qualificar',
  goal_type_qualify_desc: 'Coleta dados para o time comercial.',
  goal_type_book_label: 'Agendar',
  goal_type_book_desc: 'Conduzir para reservar uma consulta ou demo.',
  goal_type_prospect_label: 'Prospectar',
  goal_type_prospect_desc: 'Identifica e qualifica potenciais clientes.',

  list_summary: '{{active}} ativos · {{paused}} pausados',
  list_filter_label: 'Filtrar agentes',
  list_filter_all: 'Todos',
  list_filter_active: 'Ativos',
  list_filter_paused: 'Pausados',
  list_filter_draft: 'Rascunhos',
  list_search_placeholder: 'Buscar por agente ou marca…',
  list_search_loading: 'Buscando…',
  list_search_error: 'Não foi possível buscar. Tente novamente.',
  list_sort_label: 'Ordenar por',
  list_sort_updated: 'Recentes',
  list_sort_name: 'Nome',
  list_view_label: 'Modo de visualização',
  list_view_grid: 'Visualização em grade',
  list_view_list: 'Visualização em lista',
  list_col_agent: 'Agente',
  list_col_status: 'Status',
  list_col_channels: 'Contas',
  list_col_volume: 'Volume',
  list_col_trend: 'Tendência',
  list_no_channels: 'Sem canais',
  list_no_match_title: 'Nenhum agente corresponde',
  list_no_match_description: 'Tente outro filtro ou crie um novo.',
  list_stat_convs: 'Conv. (7d)',
  list_stat_convs_short: 'conversas',
  list_stat_conversion: 'Conversão',
  list_action_test: 'Testar',
  list_action_configure: 'Configurar',
  list_footer_hint_title: 'Quer uma segunda opinião sobre o seu melhor agente?',
  list_footer_hint_description:
    '{{brand}} AI pode revisar as conversas e sugerir melhorias concretas no tom, objeções comuns e marcos antes do CTA.',
  list_estimate_label: 'Est.',
  list_estimate_tooltip:
    'Estimativa por amostragem — agente de alto volume. Baseada em 30% das conversas e extrapolada.',
  list_stale_label: 'Dado desatualizado',
  list_stale_tooltip:
    'Sem novas conversas nas últimas horas, por isso o rollup não foi atualizado.',
  list_traffic_label: 'Origem do tráfego',
  list_traffic_organic: 'Orgânicas',
  list_traffic_ads: 'Ads',
  list_traffic_empty: 'Sem tráfego ainda',

  // Playground (chat with your agent, no channel attached)
  playground_title: 'Testar agente',
  playground_subtitle: 'Converse com seu agente sem passar pelo WhatsApp. É o mesmo agente e a mesma configuração; só o canal muda.',
  playground_open: 'Testar',
  playground_empty_title: 'Envie a primeira mensagem',
  playground_empty_body: 'Fale como um cliente falaria. O agente abre conforme o objetivo configurado.',
  playground_reset: 'Reiniciar conversa',
  playground_reset_done: 'Conversa reiniciada',
  playground_reset_failed: 'Não foi possível reiniciar a conversa',
  playground_send_failed: 'O agente não conseguiu responder',
  playground_empty_reply: 'O agente não retornou texto neste turno.',
  playground_trace_title: 'Rastro do turno',
  playground_trace_nodes: 'Nós',
  playground_trace_intent: 'Intenção',
  playground_trace_tone: 'Tom do lead',
  playground_trace_tools: 'Ferramentas',
  playground_trace_empty: 'Envie uma mensagem para ver o rastro.',
  playground_human_active: 'Um humano assumiu esta conversa.',
  playground_disclaimer: 'As ações são reais: o que o agente criar fica salvo.',
  playground_test_mode: 'Modo de teste',
  playground_send: 'Enviar',
  playground_placeholder: 'Escreva como um cliente falaria…',
};
